import { call, put, takeEvery } from 'redux-saga/effects'
import * as chiNhanhActions from '../ducks/chiNhanhDucks'
import * as chiNhanhApi from '../../api/chiNhanhApi'

interface FetchSaga {
  type: string
  payload: string
}

function* fetchListChiNhanh({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof chiNhanhApi.getListChiNhanh> = yield call(chiNhanhApi.getListChiNhanh, queryString)
    yield put(chiNhanhActions.getListChiNhanhSuccess(res))
  } catch (error) {
    yield put(chiNhanhActions.getListChiNhanhFail(error))
  }
}

function* fetchDetailChiNhanh({ payload: id }: FetchSaga) {
  try {
    const res: ReturnType<typeof chiNhanhApi.getDetailChiNhanh> = yield call(chiNhanhApi.getDetailChiNhanh, id)
    yield put(chiNhanhActions.getDetailChiNhanhSuccess(res))
  } catch (error) {
    yield put(chiNhanhActions.getDetailChiNhanhFail(error))
  }
}

export default function* watchChiNhanh() {
  yield takeEvery(chiNhanhActions.getListChiNhanh.toString(), fetchListChiNhanh)
  yield takeEvery(chiNhanhActions.getDetailChiNhanh.toString(), fetchDetailChiNhanh)
} 